export class CurrentUser {
    idUsuario: number;
    idEmpleado: number;
    claveUsuario: string;
    claveEmpleado: string;
    email: string;
    nombre: string;
    apellido: string;
    rol: string;
    idSucursal: number;
    claveSucursal: string;
    sucursal: string;
    puesto: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/currentUser.ts